import {
  PAYWAY_TRANSACTIONS_FETCH_REQUESTED,
  PAYWAY_TRANSACTIONS_FETCHED,
  PAYWAY_TRANSACTIONS_FETCH_FAILED,
  TOGGLE_SPINNER,
  TOGGLE_NOTIFICATION,
} from "utils/constants";
import asyncDispatcher from 'utils/asyncDispatcher';

export const fetchPaywayTransactions = () => (dispatch, getState) => {
  const { api } = getState().app;

  return asyncDispatcher(dispatch, {
    pending: PAYWAY_TRANSACTIONS_FETCH_REQUESTED,
    action: api.fetchPaywayTransactions(),
    success: PAYWAY_TRANSACTIONS_FETCHED,
    failure: PAYWAY_TRANSACTIONS_FETCH_FAILED
  });
};



// WEBPACK FOOTER //
// ./src/actions/paywayTransactions.js